const theme = {
  common: {
    doveGrey: '#666666',
    turquoise: '#03D1F9',
  },
  main: {
    black: '#000',
    white: '#fff',
    gradient: ['#ff4e54', '#f48044', '#ffb242'],
    blue: '#466AB3',
    offWhite: '#f6f7f8',
    lightBlue: '#3797F0',
    green: '#17C128',
  },
  primary: {
    light: '#fff4ef',
    main: '#ff4e54',
    dark: '#f6383f',
  },
  secondary: {
    main: '#ff8242',
    dark: '#ff6231',
  },
  grey: {
    extraLight: '#fbfbfb',
    light: '#f6f7f8',
    main: '#e1e6ea',
    dark: '#c4cdd5',
    extraDark: '#828282',
    150: '#F3F3F3',
    300: '#e0e0e0',
  },
  text: {
    extraLight: '#5d5a5a',
    light: '#293543',
    main: '#000',
    dark: '#3b3636',
  },
  error: {
    main: '#f8151d',
  },
  success: {
    main: '#07cb6e',
  },
};

module.exports = {
  theme,
  colors: {
    brand: {
      primary: {
        DEFAULT: theme.primary.main,
        light: theme.primary.light,
        dark: theme.primary.dark,
      },
      secondary: {
        DEFAULT: theme.secondary.main,
        dark: theme.secondary.dark,
      },
      bg: theme.grey.light, // #f6f7f8
      border: {
        DEFAULT: theme.grey.main, // #e1e6ea
        dark: theme.grey.dark, // #c4cdd5
      },
      text: {
        DEFAULT: theme.text.light, // #293543
        muted: theme.text.extraLight, // #5d5a5a
        dark: theme.text.dark, // #3b3636
      },
      success: {
        DEFAULT: theme.success.main, // #07cb6e
      },
      error: {
        DEFAULT: theme.error.main, // #f8151d
      },
    },
  },
};
